/**
 * Created By Jeremy.caoyu at 2019-05-14
 * baseUrl配置函数 - 重构版本
 */
import { isIP } from './util'

// ------------------- 环境配置映射 -------------------
const ENV_CONFIGS = {
  // 开发环境
  development: {
    crm: 'http://angli-api.zc.dev.myyixue.com/anglicrm/api/',
    crmApi: 'http://angli-api.zc.dev.myyixue.com/api/',
    phpUrl: 'http://test-schooladmin.myyixue.com/api',
    reportUrl: "//school-report.myyixue.com/",
    socketUrl: "//test-agent-ws.myyixue.com",
    h5Url: "//h5-school.myyixue.com/",
    monitorUrl: "http://10.173.1.13:9991",
    schoolmUrl: "http://localhost:7777/",
    verifyUrl: "https://test-s.myyixue.com/",
    crmapiv2: 'http://crmapiv2.myyixue.com/api/',
    schoolmApi: 'https://angli-api-test.songshuai.com/anglimanageapi/api/',
    schoolm: 'http://angli-api.zc.dev.myyixue.com/anglimanage/api/',
    erpUrl: "https://test-erp.myyixue.com/ForeignAPI/",
    accountCenter: '//sso-test.songshuai.com',
    dlUrl: 'https://anglidl-test.classba.cn/',
    baseUrl: 'http://angli-api.zc.dev.myyixue.com/',
    baseCrmUrl: 'http://angli-api.zc.dev.myyixue.com/',
    env: 'dev'
  },
  
  // 正式环境
  production: {
    crm: "//angli-api.songshuai.com/anglicrm/api/",
    crmApi: '//agent-crm-api.songshuai.com/api/',
    phpUrl: '//schooladmin.songshuai.com/api',
    reportUrl: "//school-report.songshuai.com/",
    socketUrl: "//agent-ws.songshuai.com",
    h5Url: "//h5-school.songshuai.com/",
    monitorUrl: "https://qrcode-sto-oss.xstudyedu.com/Monitor/index.html",
    schoolmUrl: "https://agent-schoolm.songshuai.com/",
    verifyUrl: "https://s.songshuai.com/",
    crmapiv2: 'https://crmapiv2.songshuai.com/api/',
    schoolmApi: 'https://angli-api.songshuai.com/anglimanageapi/api/',
    schoolm: "https://angli-api.songshuai.com/anglimanage/api/",
    erpUrl: "https://erp.songshuai.com/ForeignAPI/",
    accountCenter: '//sso.songshuai.com',
    dlUrl: 'https://ai.onlyedu.com/',
    baseUrl: 'https://agent-crm-api.songshuai.com/',
    baseCrmUrl: '//angli-api.songshuai.com/',
    env: 'pro'
  },
  
  // 预发布环境
  pre: {
    crm: "https://angli-api-pre.songshuai.com/anglicrm/api/",
    crmApi: '//agent-crm-api-pre.songshuai.com/api/',
    phpUrl: '//schooladmin.songshuai.com/api',
    reportUrl: "//school-report.songshuai.com/",
    socketUrl: "//agent-ws-pre.songshuai.com",
    h5Url: "//h5-school.songshuai.com/",
    monitorUrl: "https://qrcode-sto.songshuai.com/Monitor/index.html",
    schoolmUrl: "https://agent-schoolm-pre.songshuai.com/",
    verifyUrl: "https://s.songshuai.com/",
    crmapiv2: 'https://crmapiv2.songshuai.com/api/',
    schoolmApi: 'https://angli-api-pre.songshuai.com/anglimanageapi/api/',
    schoolm: "https://angli-api-pre.songshuai.com/anglimanage/api/",
    erpUrl: "https://erp.songshuai.com/ForeignAPI/",
    accountCenter: '//sso-pre.songshuai.com',
    dlUrl: 'https://anglidl-pre.classba.cn/',
    baseUrl: 'https://agent-crm-api-pre.songshuai.com/',
    baseCrmUrl: 'https://angli-api-pre.songshuai.com/',
    env: 'pre'
  },
  
  // 测试环境
  test: {
    crm: "https://angli-api-test.songshuai.com/anglicrm/api/",
    crmApi: 'https://test-agent-crm-api.myyixue.com/api/',
    phpUrl: 'https://test-schooladmin.myyixue.com/api',
    reportUrl: "https://school-report.myyixue.com/",
    socketUrl: "https://test-agent-ws.myyixue.com",
    h5Url: "https://h5-school.myyixue.com/",
    monitorUrl: "https://qrcode-sto-oss.xstudyedu.com/test/Monitor/index.html",
    schoolmUrl: "https://test-agent-schoolm.myyixue.com/",
    verifyUrl: "https://test-s.myyixue.com/",
    crmapiv2: 'https://crmapiv2.myyixue.com/api/',
    schoolmApi: 'https://angli-api-test.songshuai.com/anglimanageapi/api/',
    schoolm: "https://angli-api-test.songshuai.com/anglimanage/api/",
    erpUrl: "https://test-erp.myyixue.com/ForeignAPI/",
    accountCenter: '//sso-test.songshuai.com',
    dlUrl: 'https://anglidl-test.classba.cn/',
    baseUrl: 'https://test-agent-crm-api.myyixue.com/',
    baseCrmUrl: 'https://angli-api-test.songshuai.com/',
    env: 'dev'
  }
}

/**
 * 检测当前环境类型
 * @returns {string} 环境类型: 'development' | 'production' | 'pre' | 'test'
 */
const detectEnvironment = () => {
  const { host, hostname } = window.location
  
  // 开发环境判断
  if (host.indexOf('localhost') > -1 || isIP(hostname) || host.indexOf('mydev.myyixue.com') > -1) {
    // return 'development'
    return 'test'
  }
  
  // 特殊开发环境
  if (host === 'angli-webstatic.fe.dev.myyixue.com') {
    return 'development'
  }
  
  // 预发布环境
  if (host === 'angli-pre.songshuai.com') {
    return 'pre'
  }
  
  // 正式环境（没有前缀）
  const hasPrefix = host.match(/^.*-/)
  if (hasPrefix === null) {
    return 'production'
  }
  
  // 默认为测试环境
  return 'test'
}

/**
 * 获取当前环境配置
 * @returns {Object} 当前环境的所有配置
 */
const getCurrentConfig = () => {
  const environment = detectEnvironment()
  const config = ENV_CONFIGS[environment]
  
  // 处理特殊的IP配置（开发环境）
  if (environment === 'development' && localStorage.getItem('IP')) {
    const customIP = localStorage.getItem('IP')
    return {
      ...config,
      crm: `//${customIP}/api/`,
      // 其他需要使用自定义IP的配置也可以在这里处理
    }
  }
  
  // 处理开发环境的动态端口配置
  if (environment === 'development') {
    const { protocol, hostname } = window.location
    return {
      ...config,
      daraBaseUrl: `${protocol}//${hostname}:3001`, // 校区资料库
    }
  }
  
  // 为其他环境添加 daraBaseUrl
  const daraBaseUrls = {
    production: '//schooldb.songshuai.com',
    pre: '//schooldb.songshuai.com', 
    test: '//schooldb.myyixue.com'
  }
  
  return {
    ...config,
    daraBaseUrl: daraBaseUrls[environment] || daraBaseUrls.test
  }
}

// ------------------- 导出的主要函数 -------------------

/**
 * 获取所有基础URL配置
 * @returns {Object} 包含所有服务URL的配置对象
 */
export const getBasicUrls = () => {
  return getCurrentConfig()
}

/**
 * 获取CRM基础URL
 * @returns {string} CRM API基础URL
 */
export const getBaseUrl = () => {
  const config = getCurrentConfig()
  return config.crm
}

/**
 * 获取PHP服务URL
 * @returns {string} PHP API URL
 */
export const getPhpUrl = () => {
  const config = getCurrentConfig()
  return config.phpUrl
}

/**
 * 获取报表服务URL
 * @returns {string} 报表服务URL
 */
export const reportURL = () => {
  const config = getCurrentConfig()
  return config.reportUrl
}

/**
 * 获取Socket服务URL
 * @returns {string} WebSocket服务URL
 */
export const getSocketUrl = () => {
  const config = getCurrentConfig()
  return config.socketUrl
}

// 兼容性：保持原有的拼写错误函数名，但标记为废弃
/**
 * @deprecated 请使用 getSocketUrl 替代（修复拼写错误）
 */
export const getScoketUrl = () => {
  console.warn('getScoketUrl is deprecated, please use getSocketUrl instead')
  return getSocketUrl()
}

// ------------------- 工具函数 -------------------

/**
 * 获取当前环境名称
 * @returns {string} 环境名称
 */
export const getCurrentEnvironment = () => {
  return detectEnvironment()
}

/**
 * 检查是否为开发环境
 * @returns {boolean} 是否为开发环境
 */
export const isDevelopment = () => {
  return detectEnvironment() === 'development'
}

/**
 * 检查是否为生产环境
 * @returns {boolean} 是否为生产环境
 */
export const isProduction = () => {
  return detectEnvironment() === 'production'
}


